export default "__VITE_ASSET__BkZUyXGR__$_?nuxt_component=async&nuxt_component_name=SvgoDevelopersStructureChart&nuxt_component_export=default__"